export const getErrorMessage = (
  error: Error | any,
  defaultMessage: string = "Something went wrong"
): string => {
  const responseMessage = error?.response?.data?.message;
  // NestJS's ValidationPipe commonly returns `message` as an array of
  // per-field strings (not a single string) — passing that array/object
  // straight through as a toast's `message` prop crashes React ("Objects
  // are not valid as a React child") the moment a request fails validation
  // instead of hitting a network/auth error, which is the only shape this
  // used to be tested against.
  if (typeof responseMessage === "string") {
    return responseMessage;
  }
  if (
    Array.isArray(responseMessage) &&
    responseMessage.every((m) => typeof m === "string")
  ) {
    return responseMessage.join(", ");
  }
  return error instanceof Error ? error.message : defaultMessage;
};
